/* eslint-disable import/export */
import FileUpload from './SingleFile';
export * from './SingleFile';
export default FileUpload;